import React from "react";
import "./error.scss";
import { Link, useLocation } from "react-router-dom";
import Lottie from "lottie-react";
import MainButton from "../../Shared/MainButton";
import logo from "../../Assets/Images/Logo1.png";
import errorAnimation from "../../Assets/animations/404Animation.json";

const Error = () => {
  const location = useLocation();

  return (
    <div className="error-page">
      <div className="error-container">
        {/* Left Section (Logo) */}
        <div className="error-left">
          <img src={logo} alt="EasyTipping Logo" className="error-left-logo" />
        </div>

        {/* Right Section (Content) */}
        <div className="error-right">
          <div className="error-animation">
            <Lottie animationData={errorAnimation} loop className="animation" />
          </div>
          <h1>Page Not Found</h1>
          <p className="error-path">
            The page <code>{location.pathname}</code> doesn't exist.
          </p>
          <p className="error-description">
            The address is incorrect or the page no longer exists.
          </p>

          <Link to="/">
            <MainButton text="Go to Home" />
          </Link>
        </div>
      </div>

      <footer>
        © {new Date().getFullYear()} EasyTipping. All rights reserved.
      </footer>
    </div>
  );
};

export default Error;
